import { render, staticRenderFns } from "./BgSelectReferenceModalView.vue?vue&type=template&id=23d2c66c"
import script from "./BgSelectReferenceModalView.vue?vue&type=script&lang=js"
export * from "./BgSelectReferenceModalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports